module.exports = __webpack_public_path__ + "static/media/AGUACATE-TILA.e2cc5e39.webp";